import css from "@/components/Listing/ListingScreen/.module.scss";
import React, { useMemo } from "react";
import Icon from "@/components/icon";

const AWARENESS_MESSAGES = [
  "تعاملك يجب أن يكون مع المعلن فقط، وجود طرف ثالث قد يعني الاحتيال.",
  "إعلانك لغيرك بمقابل أو دون مقابل يجعلك مسؤولاً أمام الجهات المختصة.",
  "التواصل عبر الرسائل الخاصة بموقع عقار يقلل من الاحتيال.",
  "المحتالون يحاولون إخفاء هويتهم و يتهربون من اللقاء وتعاملهم غريب.",
  "إذا قام المسوق بتحويلك إلى شخص آخر للتواصل عبر الواتساب قد يكون احتيال.",
  "تجنب الدفع أو الحجز عبر الروابط الخارجية واحرص على عدم دفع العربون إلا بعد المقابلة أو من خلال منصة عقار.",
];
export function RandomAwarenessMessage({ listingId, ...rest }) {
  const randomMessage = useMemo(
    () => AWARENESS_MESSAGES[Math.floor(listingId % 6)],
    [listingId],
  );
  return <AwarenessMessage message={randomMessage} {...rest} />;
}
export function AwarenessMessage({ message, ...rest }) {
  return (
    <div className={css.message + " " + css.AWARNESS} {...rest}>
      <Icon width={20} height={20} name="info" />
      <div>{message}</div>
    </div>
  );
}
